import {connect} from 'react-redux'
import {Loader, utils} from "@mc/mc-legacy";
import * as React from "react";
import {Component} from "react";
import CustomerHomePage from "./customer/CustomerHomePage";
import ObjednavkyPage from "./ObjednavkyPage";
import * as opravneniActions from "../actions/opravneniActions";
import * as EnumRole from "../api/gen/cgo/EnumRole";
import './HomePage.scss';
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Domovská stránka - zobrazuje obsah podle role/oprávnění přihlášeného uživatele.
 */
class HomePage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
    };

    render() {
        const {loggedInUser, t} = this.props;

        if (!loggedInUser.fetched || loggedInUser.isFetching) {
            return <Loader/>;
        }

        switch (loggedInUser.data.role) {
            case EnumRole.UZIVATEL:
                return <CustomerHomePage/>;
            case EnumRole.OPERATOR:
                return <ObjednavkyPage/>;
            case EnumRole.ADMIN:
                return <ObjednavkyPage/>;
            case EnumRole.SPRAVSPOL:
                return <CustomerHomePage/>;
            default:
                return <div>{t('pages.no_home_page_role', {role: loggedInUser.data.role})}</div>;
        }
    }
}

function mapStateToProps(state) {
    return {
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(HomePage));
